import { observer } from "mobx-react";
import { ILabelOrSlipsLink } from "../../../../stores/rma-shipment-store";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../../../components/fonts/font-props";
import FontBody3 from "../../../../../../../components/fonts/font-body3/font-body3";
import RmaPageStore from "../../../../stores/rma-page-store";
import MissingShipmentValue from "../missing-shipment-value/missing-shipment-value";
import AHref from "../../../../../../../components/ahref/ahref";
import useDashboardTranslation from "../../../../../../../dashboard-translation/hooks/dashboard-translation-hook";

interface IProps {
    content: ILabelOrSlipsLink;
    rmaPageStore: RmaPageStore;
};

const LabelOrSlipsCell: React.FC<IProps> = observer(({ content, rmaPageStore }) => {
    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-returns-rma-card';
    if (!content.title) {
        return null;
    }
    return (
        <>
            <FontBody3 color={FONT_COLOR.PRIMARY2} variant={[FONT_VARIANT.BOLD]}>{getTranslation(content.title, pageScope)}</FontBody3>
            {(content.link.href && content.link.label && content.link.label !== '--')
                ? (
                    <AHref href={content.link.href} target="_blank" onClick={content.onLinkClick}>
                        <FontBody3 color={FONT_COLOR.ACCENT1}>{getTranslation(content.link.label, pageScope)}</FontBody3>
                    </AHref>
                )
                : (
                    <MissingShipmentValue rmaPageStore={rmaPageStore} />
                )}
        </>
    );
});

export default LabelOrSlipsCell;